import angular from 'angular';
import radialProgressBarComponent from './radialProgressBar.component';

let radialProgressBarModule = angular.module('radialProgressBar', []).component('radialProgressBar', radialProgressBarComponent);

export default radialProgressBarModule;



// WEBPACK FOOTER //
// ./app/components/radialProgressBar/radialProgressBar.js